import * as sagaEffects from 'redux-saga/effects';
import { getFirestore } from 'redux-firestore';
import { getFirebase } from 'react-redux-firebase';
import { getIntl } from '@ackee/jerome/antd';
import message from 'antd/lib/message';

import config from 'config/index';
import * as loglevel from 'config/loglevel';

import types from '../actionTypes';

import { pinsRequestCompleted } from '../actions';

const { takeEvery, put } = sagaEffects;

function* handler() {
    const firestore = getFirestore(getFirebase());
    const intl = yield getIntl();

    try {
        yield firestore.get({
            collection: `languages/${config.app.defaultLanguage}/pins`,
            storeAs: 'pins',
            orderBy: ['createdAt', 'asc'],
        });
    } catch (e) {
        loglevel.error(e);
        message.error(intl.formatMessage({ id: 'errors.pins.list' }));
    } finally {
        yield put(pinsRequestCompleted());
    }
}

export default function* () {
    yield takeEvery(types.PINS_REQUEST, handler);
}
